import { useEffect, useState } from 'react';
import { RoleData } from '../types/Role.types';

const EMPTY_PRIVILEGES: RoleData['privileges'] = {};

// Fetches the real roles catalog from GET /roles-list. The backend doesn't
// return per-module privileges yet, so they default to 'none' — same as RolesView.
export const useApiRoles = () => {
  const [roles, setRoles] = useState<RoleData[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchRoles = async () => {
      setLoading(true);
      setError(false);
      try {
        const Cookies = (await import('universal-cookie')).default;
        const cookies = new Cookies();
        const userCookie = cookies.get('101Obex');
        if (!userCookie || !userCookie.token) {
          setError(true);
          return;
        }


        const url = `/roles-list?page=1&page_size=100&access_token=${encodeURIComponent(userCookie.token)}`;

        const ObexRequestsHandlerP80 = (await import('../handlers/ObexRequestsHandlerP80')).default;
        let res = await ObexRequestsHandlerP80.get(url);
        if (res.data) res = res.data;

        const rolesData = res?.response?.data || (Array.isArray(res?.response) ? res.response : res?.result?.response?.data);
        if (Array.isArray(rolesData)) {
          setRoles(rolesData.map((r: any) => ({
            id: String(r.id),
            name: r.name,
            description: r.description || '',
            isSystem: r.is_system_role || false,
            privileges: r.privileges || EMPTY_PRIVILEGES
          })));
        } else {
          setError(true);
        }
      } catch (fetchError) {
        console.error('Error fetching roles:', fetchError);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchRoles();
  }, []);

  return { roles, loading, error };
};
